import { render } from "./VaticanNews.vue?vue&type=template&id=5d4e3183"
import script from "./VaticanNews.vue?vue&type=script&lang=js"
export * from "./VaticanNews.vue?vue&type=script&lang=js"

import "./VaticanNews.vue?vue&type=style&index=0&id=5d4e3183&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__